import React, { Component, useEffect, useState } from 'react';
import Matter, { Engine, Render, Runner, Bodies, Composite, Vertices, Svg, Body } from 'matter-js'

const Alt1 = () => {

  useEffect(() => {

    var engine = Engine.create();

    const width = window.innerWidth
    const height = window.innerHeight

    var render = Render.create({
        element: document.body.querySelector('.alt-physics'),
        engine: engine,
        options: {
          width: width,
          height: height,
          wireframes: false,
          background: 'transparent',
        }
    });

    engine.world.gravity.y = 0.2;

    var box1 = Bodies.circle(width/2, -190, 190, {
      render: {
        sprite: {
          texture: '/img/alts/el1.svg'
        }
      }
    }, 50);

    var box2 = Bodies.rectangle(width/2-150, -300, 336, 195, {
      chamfer: { radius: 50 },
      render: {
        fillStyle: '#000000',
        sprite: {
          texture: '/img/alts/el7.svg'
        }
      }
    });

    var box3 = Bodies.polygon(width/2-37, 75, 6, 75, {
      render: {
        fillStyle: '#000000',
      }
    });

    var box4 = Bodies.rectangle(width/2+200, -300, 369, 196, {
      chamfer: { radius: 90 },
      render: {
        fillStyle: '#000000',
        sprite: {
          texture: '/img/alts/el8.svg'
        }
      }
    });

    var ground = Bodies.rectangle(width/2, height, width, 1, {
      isStatic: true,
      render: {
        fillStyle: '#ffffff',
      }
    });

    let vertexSets = []

    let svgPath1 = document.querySelector('.alt-physics__svg4 path');
    let svgVertices1 = Bodies.fromVertices(width/2, -200, Vertices.scale(Svg.pathToVertices(svgPath1), 1, 1), {
      angularSpeed: 0,
      render: {
        fillStyle: '#000000',
        sprite: {
          texture: '/img/alts/el3.svg'
        }
      }
    }, true);
        
    vertexSets.push(svgVertices1);

    let svgPath2 = document.querySelector('.alt-physics__svg5 path');
    let svgVertices2 = Bodies.fromVertices(width/2, -200, Vertices.scale(Svg.pathToVertices(svgPath2), 1, 1), {
      angularSpeed: 0,
      render: {
        fillStyle: '#000000',
      }
    }, true);
        
    vertexSets.push(svgVertices2);

    let svgPath3 = document.querySelector('.alt-physics__svg7 path');
    let svgVertices3 = Bodies.fromVertices(width/2, -200, Vertices.scale(Svg.pathToVertices(svgPath3), 1, 1), {
      angularSpeed: 0,
      render: {
        fillStyle: '#000000',
        sprite: {
          texture: '/img/alts/el6.svg'
        }
      }
    }, true);
        
    vertexSets.push(svgVertices3);

    let svgPath4 = document.querySelector('.alt-physics__svg8 path');
    let svgVertices4 = Bodies.fromVertices(width/2, -200, Vertices.scale(Svg.pathToVertices(svgPath4), 1, 1), {
      angularSpeed: 0,
      render: {
        fillStyle: '#000000',
        sprite: {
          texture: '/img/alts/el2.svg'
        }
      }
    }, true); 
    vertexSets.push(svgVertices4);

    let svgPath5 = document.querySelector('.alt-physics__svg9 path');
    let svgVertices5 = Bodies.fromVertices(width/2+100, -200, Vertices.scale(Svg.pathToVertices(svgPath5), 1, 1), {
      angularSpeed: 0,
      render: {
        fillStyle: '#000000',
        sprite: {
          texture: '/img/alts/el9.svg'
        }
      }
    }, true); 
    vertexSets.push(svgVertices5);

    Body.applyForce( box1, {x: box1.position.x, y: box1.position.y}, {x: 0, y: 5});
    Body.applyForce( box2, {x: box2.position.x, y: box2.position.y}, {x: 0, y: 3});
    Body.applyForce( box3, {x: box3.position.x, y: box3.position.y}, {x: 0, y: 1});
    Body.applyForce( box4, {x: box4.position.x, y: box4.position.y}, {x: 0, y: 3});
    Body.applyForce( vertexSets[0], {x: vertexSets[0].position.x, y: vertexSets[0].position.y}, {x: 0, y: 3});
    Body.applyForce( vertexSets[1], {x: vertexSets[1].position.x, y: vertexSets[1].position.y}, {x: 0, y: 0.3});
    Body.applyForce( vertexSets[2], {x: vertexSets[2].position.x, y: vertexSets[2].position.y}, {x: 0, y: 0.3});
    Body.applyForce( vertexSets[3], {x: vertexSets[3].position.x, y: vertexSets[3].position.y}, {x: 0, y: 0.3});
    Body.applyForce( vertexSets[4], {x: vertexSets[4].position.x, y: vertexSets[4].position.y}, {x: 0, y: 0.3});

    Composite.add(engine.world, [box1, box2, box3, box4, ...vertexSets, ground]);

    Render.run(render);

    var runner = Runner.create();

    Runner.run(runner, engine);

    return() => {
      Engine.clear(engine)
    }
  },[]);

  return(
    <div className="alt-physics">
      <svg className="alt-physics__svg alt-physics__svg2" width="304px" height="259px" viewBox="0 0 791 687" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="#000000" opacity="1.00" d=" M 395.36 0.00 L 395.67 0.00 C 524.74 223.74 653.74 447.54 782.76 671.32 C 785.55 676.23 788.71 680.95 790.78 686.23 C 710.18 686.29 629.59 686.21 548.99 686.27 C 545.28 686.25 541.65 685.32 537.94 685.36 C 484.63 685.40 431.33 685.36 378.02 685.38 C 260.02 684.62 142.00 685.26 23.99 684.87 C 15.99 685.04 7.98 684.51 0.00 685.12 L 0.00 684.19 C 11.34 665.62 21.85 646.57 32.85 627.81 C 152.37 421.00 272.02 214.27 391.45 7.41 C 392.86 5.00 394.40 2.64 395.36 0.00 M 353.00 441.19 C 353.09 445.70 357.36 449.49 361.90 448.53 C 365.78 448.38 368.38 444.68 368.32 441.02 C 366.98 441.04 365.64 441.07 364.30 441.11 C 363.58 442.41 363.07 443.93 361.89 444.92 C 359.25 445.74 358.05 442.93 357.15 441.05 C 355.77 441.08 354.38 441.13 353.00 441.19 M 285.03 449.33 C 284.56 460.68 284.90 472.04 284.87 483.41 C 286.62 483.34 288.37 483.26 290.13 483.23 C 290.15 478.42 290.07 473.61 290.21 468.80 C 295.77 468.81 301.33 468.68 306.89 468.94 C 306.76 473.71 306.70 478.49 306.90 483.26 C 308.64 483.26 310.38 483.26 312.13 483.26 C 312.06 471.95 312.31 460.64 311.96 449.33 C 310.31 449.32 308.66 449.31 307.02 449.30 C 306.62 454.18 306.79 459.08 306.90 463.98 C 301.32 464.07 295.73 464.14 290.16 463.90 C 290.07 459.04 290.25 454.18 290.01 449.33 C 288.35 449.33 286.69 449.33 285.03 449.33 M 320.34 449.50 C 320.40 460.76 320.23 472.02 320.43 483.28 C 327.33 483.41 334.23 483.50 341.13 483.23 C 341.13 481.73 341.13 480.23 341.13 478.74 C 335.97 478.71 330.80 478.84 325.64 478.53 C 325.54 475.22 325.60 471.90 325.76 468.59 C 329.77 468.47 333.78 468.54 337.79 468.53 C 337.64 466.97 337.49 465.42 337.35 463.87 C 333.44 463.87 329.54 463.84 325.64 463.92 C 325.66 460.61 325.66 457.30 325.66 454.00 C 330.50 454.00 335.33 454.00 340.17 454.00 C 340.25 452.50 340.34 451.01 340.43 449.52 C 333.74 449.15 327.03 449.13 320.34 449.50 M 384.08 449.25 C 382.74 460.56 382.15 471.95 381.01 483.29 C 382.79 483.35 384.58 483.39 386.38 483.43 C 387.05 475.27 387.69 467.11 388.29 458.95 C 390.37 465.23 393.38 471.14 395.92 477.24 C 397.53 477.24 399.16 477.25 400.78 477.24 C 403.39 471.18 406.33 465.24 408.63 459.04 C 409.07 467.17 409.72 475.29 410.42 483.40 C 412.17 483.39 413.93 483.42 415.69 483.46 C 414.55 472.08 414.22 460.64 412.72 449.31 C 410.94 449.35 409.16 449.40 407.39 449.49 C 404.56 456.74 401.25 463.79 398.36 471.02 C 395.45 463.82 392.59 456.60 389.21 449.60 C 387.49 449.46 385.78 449.34 384.08 449.25 M 422.60 449.67 C 422.38 460.92 422.42 472.17 422.63 483.41 C 424.31 483.38 426.01 483.38 427.71 483.35 C 433.27 475.13 439.11 467.10 444.44 458.73 C 444.71 466.95 444.56 475.19 444.61 483.42 C 446.35 483.39 448.09 483.36 449.84 483.32 C 449.71 471.99 449.84 460.65 449.77 449.31 C 447.74 449.53 444.93 448.64 443.74 450.87 C 438.41 458.58 433.14 466.32 427.86 474.06 C 427.84 465.80 427.88 457.55 427.78 449.29 C 426.04 449.30 424.30 449.38 422.60 449.67 M 458.06 449.48 C 458.12 460.79 457.73 472.12 458.21 483.43 C 459.89 483.40 461.58 483.39 463.27 483.38 C 463.46 478.53 463.48 473.67 463.24 468.83 C 468.82 469.09 474.41 468.61 480.00 468.95 C 479.99 473.71 480.01 478.46 479.98 483.22 C 481.68 483.33 483.39 483.44 485.10 483.56 C 485.24 472.13 485.60 460.66 484.93 449.26 C 483.32 449.34 481.72 449.43 480.13 449.50 C 479.84 454.36 480.08 459.22 479.99 464.09 C 474.42 463.99 468.84 464.26 463.28 463.91 C 463.54 459.01 463.73 454.08 463.08 449.20 C 461.40 449.29 459.73 449.40 458.06 449.48 M 493.48 449.64 C 493.62 460.94 493.03 472.24 493.62 483.54 C 495.27 483.47 496.93 483.42 498.60 483.39 C 498.73 473.69 498.56 463.99 498.81 454.30 C 503.39 454.08 507.97 454.13 512.56 454.13 C 512.49 452.62 512.43 451.11 512.37 449.62 C 506.08 449.29 499.77 449.21 493.48 449.64 M 347.17 449.72 C 347.32 460.81 347.27 471.91 347.20 483.00 C 348.72 483.02 350.25 483.05 351.78 483.06 C 357.73 474.34 363.81 465.69 369.63 456.87 C 368.96 465.55 369.38 474.26 369.22 482.95 C 370.76 483.02 372.30 483.08 373.84 483.15 C 374.04 472.01 374.01 460.86 374.00 449.72 C 372.25 449.91 369.83 448.93 368.70 450.77 C 362.94 458.80 357.61 467.13 351.88 475.18 C 351.83 466.76 352.21 458.34 351.76 449.93 C 350.25 449.58 348.70 449.61 347.17 449.72 Z" />
      </svg>
      <svg className="alt-physics__svg alt-physics__svg4" width="146" height="73" viewBox="0 0 146 73" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M96.7674 73H146C146 32.6833 113.317 0 73 0C32.6832 0 0 32.6833 0 73H49.2325C49.2325 59.8735 59.8735 49.2325 73 49.2325C86.1265 49.2325 96.7674 59.8735 96.7674 73Z" fill="black"/>
      </svg>
      <svg className="alt-physics__svg alt-physics__svg5" width="124" height="124" viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.00917816 0.00919362C0.00917816 0.00919362 -1.46053 56.9878 32.776 91.2245C67.0125 125.461 123.991 123.991 123.991 123.991C123.991 123.991 125.461 67.0126 91.2243 32.776C56.9878 -1.46083 0.00917816 0.00919362 0.00917816 0.00919362Z" fill="black"/>
      </svg>
      <svg className="alt-physics__svg alt-physics__svg7" width="337" height="195" viewBox="0 0 337 195" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M336.409 26.6473C336.409 119.499 261.138 194.769 168.287 194.769C75.4359 194.769 0.165192 119.498 0.165192 26.6473V0.0140991L336.409 0.0140991V26.6473Z" fill="black"/>
      </svg>
      <svg className="alt-physics__svg alt-physics__svg8" width="305" height="262" viewBox="0 0 305 262" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M152.338 0.927856L303.026 261.928H1.64947L152.338 0.927856Z" fill="black"/>
      </svg>
      <svg className="alt-physics__svg alt-physics__svg9" width="97" height="145" viewBox="0 0 97 145" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M48.9717 0.14502L0.97168 0.14502L0.97168 48.145L0.97168 96.145H48.9717V144.145H96.9717L96.9717 96.145V48.145L48.9717 48.145V0.14502Z" fill="black"/>
      </svg>

    </div>
  )
}

export default Alt1;